import { AcademicCapIcon, HomeIcon, TrophyIcon, UserIcon } from "@heroicons/react/24/solid"
import { Navigate, NavLink, Outlet } from "react-router-dom"
import { useSelection } from "../app/department-context.tsx"
import { useProfileQuery } from "../features/auth/service.ts"
import { BaseLayout } from "./base-layout.tsx"

export function Layout() {
  const profile = useProfileQuery()
  const { currentOrganization: organization, selectedDepartment, setSelectedDepartment, departments } = useSelection()
  const currentDepartment = departments.find(d => d.id === selectedDepartment?.id)
  const showDepartmentSelector = departments.length > 1

  if (profile.isLoading) {
    return <div>Loading...</div>
  }

  if (!profile.data) {
    return <Navigate to="/login" replace />
  }

  if (profile.data.organization === null) {
    return <Navigate to="/app/admin" replace />
  }

  return (
    <BaseLayout
      menuItems={isSidebarOpen => (
        <>
          <li>
            <NavLink to="/app/dashboard" className={({ isActive }) => (isActive ? "active" : "")}>
              <HomeIcon className="w-6 h-6" />
              {isSidebarOpen && <span className="whitespace-nowrap">Сводка</span>}
            </NavLink>
          </li>
          <li>
            <NavLink to="/app/operator-report" className={({ isActive }) => (isActive ? "active" : "")}>
              <UserIcon className="w-6 h-6" />
              {isSidebarOpen && <span className="whitespace-nowrap">Отчет по оператору</span>}
            </NavLink>
          </li>
          <li>
            <NavLink to="/app/top" className={({ isActive }) => (isActive ? "active" : "")}>
              <TrophyIcon className="w-6 h-6" />
              {isSidebarOpen && <span className="whitespace-nowrap">Отчет лучшие/худшие</span>}
            </NavLink>
          </li>
          <li>
            <NavLink to="/app/fact-trends-report" className={({ isActive }) => (isActive ? "active" : "")}>
              <AcademicCapIcon className="w-6 h-6" />
              {isSidebarOpen && <span className="whitespace-nowrap">Тренды обучения</span>}
            </NavLink>
          </li>
        </>
      )}
      userInfo={
        <>
          <span className="text-sm font-medium">{profile?.data?.organization?.title || "My Organization"}</span>
          {showDepartmentSelector && currentDepartment && (
            <span className="text-xs text-teal-600 dark:text-teal-400">{currentDepartment.title}</span>
          )}
        </>
      }
      bottomMenu={() => (
        <>
          {showDepartmentSelector && (
            <>
              <li className="menu-title">
                <span>Отделы</span>
              </li>
              {departments.map(dept => (
                <li key={dept.id}>
                  <button
                    onClick={() => setSelectedDepartment(dept)}
                    className={selectedDepartment?.id === dept.id ? "active" : ""}
                  >
                    {dept.title}
                  </button>
                </li>
              ))}
              <li className="border-t border-teal-100 mt-2 pt-2"></li>
            </>
          )}
          {/*<li>
            <NavLink to="/app/settings" className={({ isActive }) => (isActive ? "active" : "")}>
              <Cog8ToothIcon className="h-6 w-6" />
              Настройки
            </NavLink>
          </li>*/}
        </>
      )}
    >
      <main className="flex-1 p-4">{profile?.data?.id && selectedDepartment?.id > 0 && <Outlet />}</main>
    </BaseLayout>
  )
}
